// Windowed page-item list for Alpine pagination controls.
// Returns 1-based page numbers interleaved with PAGE_GAP markers, capped at
// 7 slots: 1 ... c-1 c c+1 ... N. Shared by the legacy (new_page.js) and
// modern (new_new_page.js) Audio Locations steps.

export const PAGE_GAP = '...'

export function pageWindowItems(totalPages, currentPage) {
    const total = Math.max(0, Number(totalPages) || 0)
    if (total <= 7) {
        return Array.from({ length: total }, (_, i) => i + 1)
    }
    const current = currentPage + 1 // current_page is 0-based
    const start = Math.max(2, Math.min(current - 1, total - 4))
    const end = Math.min(total - 1, Math.max(current + 1, 5))
    const items = [1]
    if (start > 2) items.push(PAGE_GAP)
    for (let i = start; i <= end; i++) items.push(i)
    if (end < total - 1) items.push(PAGE_GAP)
    items.push(total)
    return items
}
